export enum FeedView {
  ALL = "All",
  NOTEWORTHY = "Noteworthy",
}
